import React from 'react'
import { Container, Row, Col } from 'react-awesome-styled-grid'

import PropTypes from 'prop-types'

import { partners, submenu } from '../../static/data/condo'
import BrandPartner from '../components/BrandPartner'
import BrandVistor from '../components/BrandVistor'
import Feature from '../components/cards/Feature'
import { featureItems } from '../components/cards/Feature/feature'
import { integrations } from '../components/cards/Feature/integrations'
import Color from '../components/helpers/Color'
import Illustration from '../components/helpers/Illustration'
import Seo from '../components/helpers/Seo'
import Shape from '../components/helpers/Shape'
import Hero from '../components/Hero'
import MobilitySlide from '../components/MobilitySlide'
import Carousel from '../components/shared/Carousel'
import Layout from '../components/shared/Layout'
import {
  SectionWrapper,
  SectionHeading,
  SectionContent
} from '../components/shared/Section'
import Title from '../components/shared/Title'
import TagTitle from '../components/shared/Title/TagTitle'
import UList from '../components/UList'
import List from '../components/UList/List'

const IndexPage = ({ pageContext, location }) => {
  const {
    breadcrumb: { crumbs }
  } = pageContext

  return (
    <Layout
      location={location}
      crumbs={crumbs}
      crumbLabel="Imobiliárias"
      submenu={submenu}
      cta={{
        headText:
          'Temos o <span>plano ideal</span> para o porte da sua imobiliária',
        actions: [
          {
            label: 'Solicite uma demo',
            to: '/#experimente-gratis',
            color: 'neutral0'
          }
        ]
      }}
    >
      <Seo
        title="Vistoriador: Aplicativo para vistoria de imóveis - Superlógica"
        description="Conheça o Vistoriador, aplicativo para vistoria de imóveis totalmente integrado com o sistema de gestão imobiliária da Superlógica. Conheça os recursos!"
      />

      <Hero
        bgColor="neutral100"
        badge={{
          label: 'App Vistoriador',
          tag: 'h1',
          icon: 'circle-imobiliarias',
          color: 'red700'
        }}
        headText="Faça vistorias inteligentes"
        bodyText="Independente de como você faz vistorias, oferecemos recursos que a sua imobiliária nem sabia que precisava."
        illustration="hero-imob-3"
        action={{
          label: 'Experimente Grátis',
          color: 'blue500'
        }}
      />

      <SectionWrapper bgColor="neutral100" afterSkew="to-right" bottom={30}>
        <Container>
          <SectionContent justify="center">
            <Carousel
              fullMobile
              dotsActiveColor="neutral100"
              settings={{
                pagination: {
                  el: '.swiper-pagination',
                  clickable: true
                },
                watchOverflow: true,
                centeredSlides: false,
                centerInsufficientSlides: true,
                spaceBetween: 32,
                slidesPerView: 4,
                initialSlide: 0,
                breakpoints: {
                  1024: {
                    slidesPerView: 4
                  },
                  640: {
                    slidesPerView: 'auto'
                  },
                  320: {
                    slidesPerView: 'auto'
                  }
                }
              }}
            >
              {featureItems.map(({ illustration, headText, bodyText }, key) => (
                <Feature
                  key={key}
                  illustration={illustration}
                  headText={headText}
                  bodyText={bodyText}
                  zindex={11}
                />
              ))}
            </Carousel>
          </SectionContent>
        </Container>
      </SectionWrapper>

      <SectionWrapper
        bgColor="blue500"
        paddingTop={280}
        paddingBottom={160}
        afterSkew30="to-right"
        marginTop={-130}
      >
        <Container>
          <SectionHeading align="center" marginBottom={100}>
            <TagTitle text="Mobilidade" color="yellow300" />
            <Title bold color="white" marginBottom={12}>
              Vistorias completas na palma da sua mão
            </Title>
            <BrandVistor />
          </SectionHeading>
        </Container>
        <Container>
          <MobilitySlide />
        </Container>
      </SectionWrapper>

      <SectionWrapper bgColor="neutral100" paddingTop={100} afterSkew="to-left">
        <SectionWrapper
          bgColor="neutral200"
          beforeSkewInvert="to-left"
          afterSkew="to-right"
          zindexAfter={2}
        >
          <Container>
            <Row align="center">
              <Col md={5}>
                <SectionContent direction="column">
                  <TagTitle text="Flexibilidade" color="blue500" />
                  <Title bold marginBottom={16}>
                    Ganhe tempo com a integração à Rede Vistorias
                  </Title>
                  <p style={{ marginBottom: '24px' }}>
                    Não tem time próprio e precisa terceirizar? Não tem
                    problema, nós integramos suas vistorias à Rede Vistorias, a
                    primeira especialista do Brasil.
                  </p>
                  <Illustration
                    width="40%"
                    name="rede-vistorias-logo"
                    marginBottom={40}
                  />
                </SectionContent>
              </Col>
              <Col md={7}>
                <Illustration
                  width="100%"
                  name="flexibility-main"
                  marginTop={-110}
                  zindex={1}
                />
              </Col>
            </Row>
          </Container>
        </SectionWrapper>
      </SectionWrapper>

      <SectionWrapper bgColor="white" paddingTop={260} paddingBottom={80}>
        <Container>
          <Row>
            <Col md={7}>
              <SectionContent direction="column">
                <Illustration
                  name="facility-main"
                  zindex={1}
                  marginBottom={32}
                  width="90%"
                />
                <Shape
                  name="line-waves"
                  color="neutral200"
                  size={350}
                  posiTop={20}
                  posiLeft={-30}
                  className="d-none d-sm-block"
                />
                <Shape
                  name="half-circle"
                  color="green400"
                  rotate={200}
                  size={45}
                  posiTop={5}
                  posiLeft={-20}
                />
                <Shape
                  name="circle"
                  color="yellow500"
                  size={18}
                  posiBottom={0}
                  posiLeft={20}
                />
              </SectionContent>
            </Col>
            <Col md={5}>
              <SectionContent direction="column" marginTop={32}>
                <TagTitle text="Facilidade" color="blue500" />
                <Title bold marginBottom={16}>
                  Facilite seu dia a dia com <br />o Módulo de Vistorias
                </Title>
                <UList>
                  <List text="Gerencie suas vistorias diretamente no sistema de gestão da Superlógica." />
                  <List text="Tenha laudos automáticos e disponibilize para assinar eletronicamente através do OwliApp." />
                  <List text="Otimize seu trabalho criando modelos de vistorias para utilizar como padrão da sua imobiliária." />
                </UList>
                <Shape
                  name="circle"
                  color="blue500"
                  size={25}
                  posiTop={0}
                  posiRight={9}
                />
                <Shape
                  name="line-circle"
                  color="red500"
                  size={130}
                  rotate={180}
                  posiBottom={-25}
                  posiRight={-10}
                />
              </SectionContent>
            </Col>
          </Row>
        </Container>
      </SectionWrapper>

      <SectionWrapper
        bgColor="neutral200"
        afterSkew="to-right"
        paddingTop={80}
        paddingBottom={40}
      >
        <Container>
          <SectionHeading align="center">
            <TagTitle text="integração" color="blue500" />
            <Title bold marginBottom={8}>
              Vistorias integradas ao sistema de gestão financeira e
              administrativa
            </Title>
            <p>Todas as funcionalidades que sua imobiliária precisa</p>
          </SectionHeading>
        </Container>
      </SectionWrapper>

      <SectionWrapper bgColor="neutral200" paddingTop={220}>
        <Shape
          name="line-waves"
          color="neutral400"
          size={300}
          posiTop={5}
          posiLeft={3}
        />
        <Shape
          name="circle"
          color="blue500"
          size={100}
          posiTop={0}
          posiRight={10}
          zindex={1}
        />
        <SectionWrapper
          bgColor="neutral100"
          beforeSkewInvert="to-right"
          marginTop={-80}
        >
          <Shape
            name="half-circle"
            color="yellow500"
            rotate={90}
            size={100}
            posiTop={5}
            posiLeft={10}
          />
          <Container>
            <SectionContent>
              <Carousel
                fullMobile
                dotsActiveColor="blue300"
                marginTop={-140}
                settings={{
                  pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                  },
                  watchOverflow: true,
                  centeredSlides: false,
                  centerInsufficientSlides: true,
                  spaceBetween: 32,
                  slidesPerView: 4,
                  initialSlide: 0,
                  breakpoints: {
                    1024: {
                      slidesPerView: 4
                    },
                    640: {
                      slidesPerView: 'auto'
                    },
                    320: {
                      slidesPerView: 'auto'
                    }
                  }
                }}
              >
                {integrations.map(
                  ({ illustration, headText, bodyText }, key) => (
                    <Feature
                      key={key}
                      illustration={illustration}
                      headText={headText}
                      bodyText={bodyText}
                      zindex={11}
                    />
                  )
                )}
              </Carousel>
            </SectionContent>
          </Container>
        </SectionWrapper>
      </SectionWrapper>

      <SectionWrapper
        className="product-press"
        bgColor="neutral100"
        paddingBottom={220}
        paddingTop={120}
      >
        <Container>
          <SectionHeading align="center" marginBottom={20}>
            <Title bold>
              Mais de <Color color="blue500">75 mil vistorias</Color> criadas na
              plataforma
            </Title>
          </SectionHeading>
          <SectionContent>
            <Row justify="center">
              {partners.map((partner, i) => (
                <Col key={i} xs={6} md={2}>
                  <BrandPartner partner={partner} />
                </Col>
              ))}
            </Row>
          </SectionContent>
        </Container>
      </SectionWrapper>
    </Layout>
  )
}

IndexPage.propTypes = {
  pageContext: PropTypes.object,
  location: PropTypes.object
}

export default IndexPage
